export default {
  Index: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Micromall: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  ChainE: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Community: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  B2B2C: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Retail: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  CloudPurchase: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  LiveBroadcast: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Finance: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Cashier: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Payment: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Member: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Popularize: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  BrandCustom: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  DistributeCustom: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  ShopCustom: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  O2OCustom: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Supplychain: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  AgentOperation: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Cooperate: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  EcoPartner: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Introduce: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  },
  Dynamic: {
    title: '汇通达网络股份有限公司',
    meta: [{
      name: 'keywords',
      content: '汇通达'
    }, {
      name: 'description',
      content: '汇通达'
    }]
  }
}
